module.exports = __webpack_public_path__ + "media/images/img_opportunity01-1b5cfdee0a98e2a26e796307676542e4.png";